import { gql, useMutation } from '@apollo/client';
import {
  createClient as CREATE_CLIENT,
  EntityUser,
} from '@admiin-com/ds-graphql';

export const useCreateClient = () => {
  const [createClient, { loading, error }] = useMutation(gql(CREATE_CLIENT), {
    update(cache, { data: { createClient } }) {
      // Create a reference to the new entity user
      const createdClientRef = cache.writeFragment({
        data: createClient,
        fragment: gql`
          fragment NewEntityUser on EntityUser {
            id
            entityId
            userId
            role
            invitedEntityId
            firstName
            lastName
            role
            entitySearchName
            entity
            searchName
            createdBy
            createdAt
            updatedAt
          }
        `,
      });

      // Update entityUsersByUser cache
      cache.modify({
        fields: {
          entityUsersByEntityId(existingEntityUsersRef = {}, { readField }) {
            const existingItems = existingEntityUsersRef.items
              ? (readField('items', existingEntityUsersRef) as EntityUser[])
              : [];
            const existingTotal = existingEntityUsersRef.total
              ? (readField('total', existingEntityUsersRef) as number)
              : 0;

            return {
              ...existingEntityUsersRef,
              items: [createdClientRef, ...existingItems],
              total: existingTotal + 1,
            };
          },

          // Update entityUsersByFirmId cache
          entityUsersByFirmId(existingEntityUsersRef = {}, { readField }) {
            const existingItems = existingEntityUsersRef.items
              ? (readField('items', existingEntityUsersRef) as EntityUser[])
              : [];
            const existingTotal = existingEntityUsersRef.total
              ? (readField('total', existingEntityUsersRef) as number)
              : 0;

            return {
              ...existingEntityUsersRef,
              items: [createdClientRef, ...existingItems],
              total: existingTotal + 1,
            };
          },
        },
      });
    },
  });

  return { createClient, loading, error };
};
